function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M17 0H7a7 7 0 00-7 7v10a7 7 0 007 7h10a7 7 0 007-7V7a7 7 0 00-7-7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF8415",
  d: "M17 2a5 5 0 015 5v10a5 5 0 01-5 5H7a5 5 0 01-5-5V7a5 5 0 015-5h10z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M11 19H9v-1H5v-1h4v-2.5H5v-1h4V11H5V9h4V5h2v4h2.5V5h1v4H17V5h1v4h1v2h-1v2.5h1v1h-1V17h1v1h-1v1h-1v-1h-2.5v1h-1v-1H11v1zm0-2h2.5v-2.5H11V17zm6-2.5h-2.5V17H17v-2.5zm-6-1h2.5V11H11v2.5zm6-2.5h-2.5v2.5H17V11z"
}));

function SvgQInteractiveTableCompletedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
}

export default SvgQInteractiveTableCompletedIcon;